<template>
  <div id="app">
    <fdp-header />
    <router-view />
    <fdp-footer />
    <terms-modal />
  </div>
</template>
<script lang="ts">
import FdpFooter from './components/FdpFooter/index.vue'
import FdpHeader from './components/FdpHeader/index.vue'
import TermsModal from './components/TermsModal/index.vue'

export default {
  components: {
    FdpFooter,
    FdpHeader,
    TermsModal,
  },
}
</script>
<style lang="scss">
@import "scss/main";
</style>
